import React from 'react';
import { VippedPage } from '../../components/Views/VippedPage';
import { getSeoData } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';
import { getFilterVariantsForVipPage } from '../../api/queries';
import { getStaticData } from '../../utils/helpers/getStaticData';
import { parseVippedFiltersFromQuery } from '../../utils/helpers/vipped';
import { getBreadcrumbs } from '../../utils/helpers/getBreadcrumbs';
import { getI18nForLang } from '../../utils/helpers/getI18nForLang';
import CONFIG from '../../config';
import { withBugsnagGetServerSideProps } from '../../utils/withBugsnag';
import { getLocaleOnSSR } from '../../utils/helpers/getLocaleOnSSR';
import { extractApolloState } from '../../utils/helpers/extractApolloState';
import { prepareSSRContext } from '../../utils/helpers/ssrContext';

const Vipped = props => <VippedPage {...props} />;

export const getServerSideProps = withBugsnagGetServerSideProps(
  async ctx => {
    const { req, query } = ctx;
    const {
      apolloClient,
      apolloOptions,
      asPath,
      currentLang,
      isSSRWebView,
      abTests,
      hasAccessToken
    } = prepareSSRContext(ctx);

    const adaptFilter = parseVippedFiltersFromQuery(query);
    const isBaseVipPage = !Object.keys(adaptFilter).length;

    try {
      const [filterVariantsForVipPage, seoData] = await Promise.all([
        apolloClient.query({ query: getFilterVariantsForVipPage }),
        getSeoData(apolloClient, asPath, req),
        getStaticData(apolloClient)
      ]);

      const { breadcrumbs, currAdaptFilter } = getBreadcrumbs(
        filterVariantsForVipPage?.data,
        adaptFilter,
        'vipped'
      );

      return extractApolloState(apolloClient, {
        props: {
          seoData,
          breadcrumbs,
          isBaseVipPage,
          adaptFilter: currAdaptFilter,
          currentLang,
          apolloOptions,
          isSSRWebView,
          abTests,
          hasAccessToken
        }
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  },
  '/vipped',
  ({ req }) => ({
    isBaseVipPage: true,
    adaptFilter: {},
    breadcrumbs: [],
    seoData: {},
    currentLang: getLocaleOnSSR(req),
    ssrError: true
  })
);

Vipped.getLayout = (page, pageProps) => {
  const currentLang = pageProps?.currentLang || CONFIG.defaultLocale;
  const i18n = getI18nForLang(currentLang);

  return (
    <Layout
      noBorder
      isShowBackButton
      isBottomNavigation
      hideMobileHeader
      headerTitle={i18n.t('sections.vipped.title')}
    >
      {page}
    </Layout>
  );
};

export default Vipped;
